module.exports = __webpack_public_path__ + "assets/img/0614.7031a004.svg";